// removed by extract-text-webpack-plugin
module.exports = {"Poke":"Poke__Poke__23Ir3","Add":"Poke__Add__2PcZ_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Poke/Poke.css
// module id = 145
// module chunks = 0